import { type ReactElement } from 'react';
import { Navigate } from 'react-router';
import { recallAnyCheckout } from '@/lib/checkout-memory';

// A real provider lands on one URL and names its order, not ours: the tab says
// which booking, and which day it was for. §12 keeps the address out of the URL.
export function returnTo(): string {
  const kept = recallAnyCheckout();
  if (kept === null) return '/';
  const day = kept.date === undefined ? '' : `&date=${encodeURIComponent(kept.date)}`;
  return `/${kept.slug}?code=${encodeURIComponent(kept.code)}${day}`;
}

export function ReturnPage(): ReactElement {
  return <Navigate to={returnTo()} replace />;
}
